import React from 'react';
import { Route, Redirect } from 'react-router-dom';



function OpenRoute({ component: Component, ...rest }) {
    const user = null;
    return (
        <Route
            {...rest}
            render={props =>
                user ? <Redirect to='/secured' /> : <Component {...props} />
            }
        />
    );
}

export default OpenRoute;